export default __webpack_public_path__ + "static/media/icon_05_frontend.ee97676b.svg";